import { CampaignParams } from '@components/Dashboard/dashboardSlice/campaignsApi';
import { rootApi } from '@components/rootApi';
import {
  CostPerVisitResponse,
  ReturnOnAdSpendResponse,
  costPerVisitResponse,
  returnOnAdSpendResponse,
} from './schema';

type CostPerVisitParams = {
  visits: number;
  ad_spend: number;
  start_date: string;
  end_date: string;
  report_date: string;
};

type ReturnOnAdSpendParams = {
  sales: number;
  ad_spend: number;
  start_date: string;
  end_date: string;
  report_date: string;
};

const reportsApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    scheduleReportPancakeDownload: builder.mutation<void, string>({
      query: jobId => ({
        url: `/api/reports/${jobId}/schedule_pancake_download`,
        method: 'PATCH',
      }),
    }),

    getFlatReportVerification: builder.query<
      { is_blank: boolean },
      CampaignParams
    >({
      query: params => {
        return {
          url: '/flat_reports',
          params: { ...params, isVerify: true },
        };
      },
    }),

    getCostPerVisitCalculation: builder.query<
      CostPerVisitResponse,
      CostPerVisitParams
    >({
      query: params => {
        return {
          url: '/api/calculations/cost_per_visit',
          params,
        };
      },
      transformResponse: response => {
        return costPerVisitResponse.parse(response);
      },
    }),

    getReturnOnAdSpendCalculation: builder.query<
      ReturnOnAdSpendResponse,
      ReturnOnAdSpendParams
    >({
      query: params => {
        return {
          url: '/api/calculations/return_on_ad_spend',
          params,
        };
      },
      transformResponse: response => {
        return returnOnAdSpendResponse.parse(response);
      },
    }),
  }),
});

export const {
  useScheduleReportPancakeDownloadMutation,
  useGetFlatReportVerificationQuery,
  useGetCostPerVisitCalculationQuery,
  useGetReturnOnAdSpendCalculationQuery,
} = reportsApi;
